/** 不与 request/storage 耦合，避免循环引用 */
export const PERMISSION_CODES_STORAGE_KEY = "yqq_permission_codes";
